import { createFileRoute, redirect } from "@tanstack/react-router";

import { LegacyStaffForm } from "@/components/staff/LegacyStaffForm";
import { env } from "@/config/env";
import { useGetUser } from "@/generated/users/users";

/**
 * The old Edit Staff screen. While the People Hub is switched off this is the
 * live page; once it's on, the person's profile under /people takes over and
 * old links still land.
 */
export const Route = createFileRoute("/_authenticated/settings/staff/$id/edit")(
  {
    beforeLoad: ({ params }) => {
      if (env.VITE_PEOPLE_HUB_ENABLED) {
        throw redirect({
          to: "/people/$userId",
          params: { userId: params.id },
        });
      }
    },
    component: EditStaffPage,
  },
);

function EditStaffPage() {
  const { id: userId } = Route.useParams();

  const { data: userResponse, isLoading } = useGetUser(userId);

  const user = userResponse?.data ?? null;

  return <LegacyStaffForm mode="edit" user={user} isLoading={isLoading} />;
}
